import React, { useEffect, useState, useContext } from 'react';
import M from 'materialize-css'
import { axios } from '../../../config';
import { UserContext } from '../../../UserContext';

const Recoleccion = () => {

	const { configs, setConfigs } = useContext(UserContext);

	useEffect(()=>{
		M.FormSelect.init(document.querySelectorAll('select'), {});

		const onCloseEnd = () => {
			const hora = document.querySelector('#hora_recoleccion')
			hora.value=hora.value.slice(0,-2)+'00'
		}
		M.Timepicker.init(document.querySelectorAll('.timepicker'), {twelveHour:false, onCloseEnd});
	},[])

	const _save = (e) => {

		e.preventDefault()

		const hora = document.querySelector('#hora_recoleccion').value
		axios.post('/api/horario_recoleccion_fedex',{recolecciones:{...configs.recolecciones, hora, dias:configs.recolecciones.tipo_recoleccion==='diaria'?['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado']:(configs.recolecciones.tipo_recoleccion==='tres_veces'?['Lunes','Miércoles','Viernes']:configs.recolecciones.dias) }})
		.then(r=>{
			M.toast({html:'Horario de recolección actualizado'})
		})
		.catch(r=>alert(r))
	}

	const _returnOptions = ()=> {
		switch(configs.recolecciones.tipo_recoleccion){
			case 'diaria':
				return (<div className='input-field col s12'>
						<div> Dias seleccionados: </div>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Lunes</a>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Martes</a>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Miércoles</a>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Jueves</a>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Viernes</a>
						<a href='#!' className='btn waves-effect waves-light black' style={{margin:5}}>Sábado</a>
					</div>)
			case 'semanal':
				return (<div className='input-field col s12'>
						<div>Seleccione un día de la semana: </div>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Lunes'?'black':'grey'}`} onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Lunes']}})} style={{margin:5}}>Lunes</a>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Martes'?'black':'grey'}`}  onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Martes']}})} style={{margin:5}}>Martes</a>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Miércoles'?'black':'grey'}`}  onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Miércoles']}})} style={{margin:5}}>Miércoles</a>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Jueves'?'black':'grey'}`}  onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Jueves']}})} style={{margin:5}}>Jueves</a>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Viernes'?'black':'grey'}`}  onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Viernes']}})} style={{margin:5}}>Viernes</a>
						<a href='#!' className={`btn waves-effect waves-light ${configs.recolecciones.dias&&configs.recolecciones.dias.length===1&&configs.recolecciones.dias[0]==='Sábado'?'black':'grey'}`}  onClick={()=>setConfigs({...configs,recolecciones:{...configs.recolecciones, dias:['Sábado']}})} style={{margin:5}}>Sábado</a>
					</div>)
			case 'tres_veces':
				return (<div className='input-field col s12'>
						<div>Días seleccionados: </div>
						<a href='#!' className={`btn waves-effect waves-light black`} style={{margin:5}}>Lunes</a>
						<a href='#!' className={`btn waves-effect waves-light grey`} style={{margin:5}}>Martes</a>
						<a href='#!' className={`btn waves-effect waves-light black`} style={{margin:5}}>Miércoles</a>
						<a href='#!' className={`btn waves-effect waves-light grey`} style={{margin:5}}>Jueves</a>
						<a href='#!' className={`btn waves-effect waves-light black`} style={{margin:5}}>Viernes</a>
						<a href='#!' className={`btn waves-effect waves-light grey`} style={{margin:5}}>Sábado</a>
					</div>)
			default: break
			}
	}

	return(
		<div className='card-panel'>
			<form onSubmit={_save}>
			<h4>Horario de recolección</h4>
			<p>Para pedidos/clientes con recogida en tienda</p>
			<div className='row'>
				<div className='input-field col s12'>
					<select value={configs.recolecciones.tipo_recoleccion||''} onChange={(e)=>setConfigs({...configs, recolecciones: {...configs.recolecciones,tipo_recoleccion:e.target.value}})} required>
						<option value="" disabled>Elija un tipo</option>
						<option value="diaria">Diaria</option>
						<option value="semanal">Una vez por semana</option>
						<option value="tres_veces">Tres veces por semana</option>
					</select>
					<label>Selecciona</label>
				</div>
				{_returnOptions()}
				<div className='input-field col s2'>
					<div>Recogida disponible desde:</div>
					<input id='hora_recoleccion' defaultValue={configs.recolecciones.hora} type='text' className='timepicker' placeholder='seleccionar' />
				</div>
			</div>
			<h4>Dirección</h4>
			<div className="row">
				<div className="input-field col s4">
					<input value={configs.recolecciones.PickupLocation.Contact.PersonName||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Contact:{...configs.recolecciones.PickupLocation.Contact, PersonName:e.target.value}}}})} id="nombre_contacto" type="text" className="validate" />
					<label htmlFor="nombre_contacto">Nombre del contacto</label>
				</div>
				<div className="input-field col s4">
					<input value={configs.recolecciones.PickupLocation.Contact.PhoneNumber||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Contact:{...configs.recolecciones.PickupLocation.Contact, PhoneNumber:e.target.value}}}})} id="telefono_contacto" type="text" className="validate" />
					<label htmlFor="telefono_contacto">Teléfono contacto</label>
				</div>
				<div className="input-field col s4">
					<input value={configs.recolecciones.PickupLocation.Contact.CompanyName||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Contact:{...configs.recolecciones.PickupLocation.Contact, CompanyName:e.target.value}}}})} id="nombre_empresa" type="text" className="validate" />
					<label htmlFor="nombre_empresa">Nombre empresa/lugar</label>
				</div>
			</div>
			<div className="row">
				<div className="input-field col s12">
					<input value={configs.recolecciones.PickupLocation.Address.StreetLines[0]||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Address:{...configs.recolecciones.PickupLocation.Address, StreetLines:[e.target.value, configs.recolecciones.PickupLocation.Address.StreetLines[1]]}}}})} id="calle_numero" type="text" className="validate" />
					<label htmlFor="calle_numero">Calle y Número</label>
				</div>
				<div className="input-field col s12">
					<input value={configs.recolecciones.PickupLocation.Address.StreetLines[1]||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Address:{...configs.recolecciones.PickupLocation.Address, StreetLines:[configs.recolecciones.PickupLocation.Address.StreetLines[0], e.target.value]}}}})} id="colonia" type="text" className="validate" />
					<label htmlFor="colonia">Colonia</label>
				</div>
				<div className="input-field col s12">
					<input value={configs.recolecciones.PickupLocation.Address.City||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Address:{...configs.recolecciones.PickupLocation.Address, City:e.target.value}}}})} id="ciudad" type="text" className="validate" />
					<label htmlFor="ciudad">Ciudad</label>
				</div>
				<div className="input-field col s12">
					<input value={configs.recolecciones.PickupLocation.Address.PostalCode||''} onChange={(e)=>setConfigs({...configs, recolecciones:{...configs.recolecciones,PickupLocation:{...configs.recolecciones.PickupLocation,Address:{...configs.recolecciones.PickupLocation.Address, PostalCode:e.target.value}}}})} id="cp" type="text" className="validate" />
					<label htmlFor="cp">Código postal</label>
				</div>
			</div>




			<button href='#!' className='btn black'>Guardar</button>
			</form>
		</div>
	)
}

export default Recoleccion
